import { callGet, callPost } from '../../services/axios'
import { splitArrayInToChunks } from '../../services/helper'
import axios from 'axios'
import {
  UPLOAD_DATA,
  CLEAR_UPLOAD_DATA,
  MATCH_UPLOAD_DATA,
  UPLOAD_FINAL_DATA_START,
  UPLOAD_FINAL_DATA_SUCCESS,
  UPLOAD_FINAL_DATA_FAILED,
  PARSED_FULL_ADDRESS,
  DB_MATCH_START,
  DB_MATCH_SUCCESS,
  DB_MATCH_FAIL,
} from '../actionTypes/upload'


export const uploadData = (data) => (dispatch) => {
  dispatch({
    type: UPLOAD_DATA,
    payload: data,
  })
}

export const clearUploadData = () => (dispatch) => {
  dispatch({
    type: CLEAR_UPLOAD_DATA,
  })
}

export const matchUploadedData = (data) => async (dispatch) => {
  await dispatch({
    type: MATCH_UPLOAD_DATA,
    payload: data,
    dispatch
  })
}

export const inputData = (arrData) => {
  const result = arrData.map(row => {
    const tmp = row;
    if (tmp.supplier.masterId == '') { tmp.supplier.masterId = 0 }
    return tmp;
  })
  return result;
}

export const uploadFinalData = (dataArr) => async (dispatch, getState) => {
  const { auth: { user, token }, domain: { currentDomain } } = getState()
  const { id: userId } = user
  const { id: domainId } = currentDomain
  dispatch(uploadFinalDataStart())

  var userName = user?.firstname + (user?.lastname ? ' ' + user?.lastname : '')
  let result;
  let allSuppliersUploaded = [];
  let allMasterSuppliersUploaded = [];

  try {
    for (let i = 0; i < dataArr.length; i++) {
      result = await callPost(`/api/supplier/uploadSuppliers`, {
        userId,
        domainId,
        data: dataArr[i],
        userName
      }, token)
      allSuppliersUploaded.push(result['data']['suppliers'])
      allMasterSuppliersUploaded.push(result['data']['masterSuppliers'])
    }
    let allSuppliers = [].concat.apply([], allSuppliersUploaded);
    let allMasterSuppliers = [].concat.apply([], allMasterSuppliersUploaded);
    dispatch(uploadFinalDataSuccess(allSuppliers))
    return {
      allSuppliers,
      allMasterSuppliers
    };
  } catch (error) {
    dispatch(uploadFinalDataFailed())
    return error
  }
}

export const uploadFinalDataStart = () => {
  return { type: UPLOAD_FINAL_DATA_START }
}
export const uploadFinalDataSuccess = (data) => {
  // return { type: UPLOAD_FINAL_DATA_SUCCESS, data: data?.suppliers }
  return { type: UPLOAD_FINAL_DATA_SUCCESS, data: data }
}
export const uploadFinalDataFailed = () => {
  return { type: UPLOAD_FINAL_DATA_FAILED }
}

export const parseFullAddress = (address) => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet(`/api/supplier/parseFullAddress`, token, {
    address
  }).then((res) => {
    return Promise.resolve(res['data'])
  }).catch((err) => {
    return Promise.reject({ message: err })
  })
}

export const setParsedFullAddress = (isParsed) => {
  return { type: PARSED_FULL_ADDRESS, data: isParsed }
}

export const dbMatch = ({ data, listData, partnerName, callingScriptId, listId = null }) => async (dispatch, getState) => {
  const { auth: { user, token }, domain: { currentDomain } } = getState()
  const { id: userId } = user
  const { id: domainId } = currentDomain
  var userName = user?.firstname + (user?.lastname ? ' ' + user?.lastname : '')
  let result;
  dispatch({
    type: DB_MATCH_START
  })

  try {
    result = await callPost(`/api/supplier/dbListMatch`, {
      data: data,
      listData,
      partnerName,
      userId,
      domainId,
      userName,
      callingScriptId,
      listId
    }, token)
    dispatch({
      type: DB_MATCH_SUCCESS
    })
    return result['data'];
  } catch (error) {
    dispatch({
      type: DB_MATCH_FAIL
    })
    return error
  }
}

export const testFuseJsSettings = ({ data, fuseJsOptions, isRunEsMatch, isUseFullAddressMatch = false }) => async (dispatch, getState) => {
  let result;
  let allData = []
  let allsuppliers = []
  const { auth: { token } } = getState()
  try {
    for (let i = 0; i < data.length; i++) {
      result = await callPost(`/api/supplier/testFuseJsSettings`, {
        data: data[i]?.supplier,
        options: fuseJsOptions,
        allSuppliersData: allsuppliers,
        isRunEsMatch,
        isUseFullAddressMatch
      }, token)

      allData.push({ data: result?.['data']?.['data'], matchedId: result?.['data']?.['matchedId'] })
      allsuppliers = result?.['data']?.allSuppliers || []
    }
    let allListSuppliers = [].concat.apply([], allData);

    return allListSuppliers;
  } catch (error) {
    dispatch({
      type: DB_MATCH_FAIL
    })
    return error
  }
}

export const deleteFailedListbyId = (id) => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  try {
    return callPost("/api/supplier/deleteFailedListAndListSuppliers", { id }, token).then(res => {
      return Promise.resolve(res['data'])
    }).catch(err => {
      console.log("err", err)
      return Promise.reject({ message: err })
    })
  } catch (err) {
    console.log("err", err)
  }
}

export const bulkUpdatSupplierData = (dataArr, type) => async (dispatch, getState) => {
  const { auth: { token }, domain: { currentDomain } } = getState()
  const { id: domainId } = currentDomain
  dispatch(uploadFinalDataStart())
  let result;
  try {
    for (let i = 0; i < dataArr?.length; i++) {
      result = await callPost(`/api/supplier/bulkUpdateSuppliers`, {
        domainId,
        data: dataArr[i],
        type
      }, token)
    }
    dispatch(uploadFinalDataSuccess([]))
    return {
      result
    };
  } catch (error) {
    dispatch(uploadFinalDataFailed())
    return error
  }
}

export const importFileData = (formData, actionType, supplierType, onUploadProgress) => (dispatch, getState) => {
  const { auth: { token }, domain: { currentDomain } } = getState();
  const { id: domainId } = currentDomain;

  formData.append('domainId', domainId);

  return axios.post(`/api/supplier/importFileData`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Authorization": `Bearer ${token}`
    },
    onUploadProgress,
  });
};

export const uploadFileUsingMulter = (fileFormData) => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  try {
    return axios.post(`/api/supplier/uploadFileUsingMulter`, fileFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": `Bearer ${token}`
      },
    });
  } catch (err) {
    console.log("err", err)
  }
}